import _ from 'lodash';

export const TABS = {
  JOURNEY_PLANNER: '/journey-planner',
  LIVE_DEPARTURES: '/live-departures',
  TIMETABLES: '/timetables',
};

export const DEFAULT_TAB = TABS.JOURNEY_PLANNER;

const isValidUrl = url => _.some(TABS, tabUrl => _.startsWith(url, tabUrl));

export default {
  isValidUrl,
};
